import { NumericFormat } from "react-number-format";
import { BcFieldProps } from "../../../interface/props/bcfield";
import { BCInputCont } from "../../../styled/global.styled";

const CurrencyField = ({ field, register, isRequired, errors }: BcFieldProps) => (
    <BCInputCont className="bc-form-field">
        <NumericFormat
            thousandSeparator={'.'}
            prefix={'$'}
            decimalSeparator={','}
            className="bc-input"
            aria-label={field.label}
            placeholder={field.placeholder}
            id={field.item}
            {...register(field.item, { required: isRequired, valueAsNumber: true })}
        />
        <label htmlFor={field.item}>{field.label}</label>
        {errors && <span>Help Text</span>}
    </BCInputCont>
);

export default CurrencyField